import React from "react";
import {List, ListItem, styled, Typography} from "@mui/material";
import {THEME_CONFIG} from "../../../config";

const {poll} = THEME_CONFIG

export default function QuizQuestion({risposte, corretta, hideResult = false, answer, sendAnswer, isPoll}) {
    const RispostaStyled = styled(ListItem)({
        border: `2px solid ${poll.default}`,
        borderRadius: '0.7rem',
        background: poll.default,
        margin: '1rem 0',
        cursor: 'pointer',
    })

    const computeBkg = (r) => {
        if(!isPoll && hideResult === false) {
            if (answer !== '') {
                if (corretta === r) {
                    return poll.correct
                } else if (answer === r  && answer !== corretta){
                    return poll.wrong
                }
            }
        } else {
            if(answer === r) {
                return poll.answered
            }
        }

    }

    const Risposte = () => (
        risposte.map((r, i) => (
            <RispostaStyled key={i} style={{
                width: '100%',
                background: computeBkg(r),
                border: computeBkg(r) ? '1px solid '+'rgba(236,239,241,0.45)' : `2px solid ${poll.default}`,
                boxShadow: computeBkg(r) ? ('0 0 10px 2px '+'rgba(255,0,128,0.8)') : 'none',
                color: 'white',
            }} onClick={() => rispondi(r)}>
                <Typography variant={"h6"} fontWeight={computeBkg(r) ? 'bold' : 'inherit'}>
                    {i + 1}. {r}
                </Typography>
            </RispostaStyled>
        ))
    )

    const rispondi = (r) => {
        if(isPoll) {
            sendAnswer(r)
        } else {
            if(answer === ''){

                sendAnswer(r)
            }
        }
    }

    return (
        <List>
            <Risposte/>
        </List>
    )
}
